import { render, staticRenderFns } from "./DeductionListItem.vue?vue&type=template&id=1faec473&scoped=true&"
import script from "./DeductionListItem.vue?vue&type=script&lang=js&"
export * from "./DeductionListItem.vue?vue&type=script&lang=js&"
import style0 from "./DeductionListItem.vue?vue&type=style&index=0&id=1faec473&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1faec473",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VChip,VIcon})
